import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/** Navy (the cover's title color) is the action color on this light page. */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-5 text-lg sm:text-xl rounded-full min-h-[64px]' : 'px-5 py-3 text-sm rounded-full';
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 bg-navy text-center font-display font-semibold tracking-tight text-white shadow-card transition-[background-color,box-shadow] duration-200 hover:bg-teal-deep hover:shadow-lift focus:outline-none focus-visible:ring-4 focus-visible:ring-teal/40 ${sizing} ${className}`} data-id="element-117" data-mp="qi7ftqsp9qae">
      {children}
    </a>;
}